module.exports = __webpack_public_path__ + "static/media/YB5M13_1.f8e4428e.jpg";